"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Step = void 0;
const react_1 = __importDefault(require("react"));
const classFunctions_1 = require("../../../utils/classFunctions");
require("./style.scss");
const Step = (props) => {
    const { first, state, handleClick } = props;
    const classNames = (0, classFunctions_1.getClassNames)('step', [
        first ? 'first' : undefined,
        state === 'not-filled' ? 'not-filled' : undefined,
        state === 'active' ? 'active' : undefined,
        handleClick ? 'clickable' : undefined,
    ]);
    const style = {
        ['--arrow-color']: props.arrowColor,
    };
    const optionalProps = {};
    if (props.handleClick) {
        optionalProps.onClick = props.handleClick;
    }
    return (react_1.default.createElement("div", { ...optionalProps, className: classNames, style: style },
        react_1.default.createElement("span", { className: 'step__arrow' }),
        props.children));
};
exports.Step = Step;
//# sourceMappingURL=Step.js.map